<ng-content select="app-side-list-item"></ng-content>
